<template>
  <section>
    <b-modal
      :active="show"
      @close="closeModalMessages"
      has-modal-card
    >
      <div class="modal-card">
        <form class="lm-forms">
          <header class="modal-card-head">
            <b-icon
            icon="email-outline"
            size="is-small"
          />
          <div
            class="lr-modal-title"
            v-t="$t('ModalMessages.title', { orderID: customerID })"
          />
          </header>
          <main id="container" class="modal-card-body modal-messages__body-messages">
            <messages-list
              :feed="feeds"
            />
          </main>

          <footer class="modal-card-foot">
            <div class="modal-align-textarea-messages">
              <b-input
                maxlength="140"
                type="textarea"
                v-model.trim="$v.message.$model"
                :disabled="textareaDisabled"
                @focus="focus"
                @blur="focus"
                @keyup.native.enter="send"
              />
            </div>
            <div class="buttons local-lr-pull-right local-lr-align-btn-send">
              <b-button
                class="lm-default-btn--no-outline"
                icon-right="send"
                :disabled="disabled"
                @click.prevent="send"
              />
            </div>
          </footer>

        </form>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'
import MessagesList from '@/components/messages/MessagesList'
import { mapGetters } from 'vuex'

export default {
  name: 'ModalMessages',
  beforeDestroy () {
    this.$eventBus.$off('messagesScrollToBottom')
  },
  components: {
    MessagesList
  },
  computed: {
    ...mapGetters('messages', [
      'show',
      'content'
    ]),
    orderID () {
      return this.content.id
    },
    customerID () {
      return this.content.customerOrderCode
    },
    feeds () {
      return this.content.messages
    }
  },
  watch: {
    show: function (changes) {
      // ! everytime changed the modal visibility check if the closeModalMessages event was fired
      if (changes) {
        this.$eventBus.$on('closeModalMessages', () => {
          this.closeModalMessages()
        })
      }
    },
    deep: true
  },
  data () {
    return {
      message: null,
      disabled: true,
      textareaDisabled: false
    }
  },
  mounted () {
    this.$eventBus.$on('messagesScrollToBottom', () => {
      this.scrollToBottom()
    })
  },
  methods: {
    closeModalMessages () {
      this.$store.dispatch('messages/disable')
      this.$eventBus.$emit('closeModal')
    },
    scrollToBottom () {
      setTimeout(() => {
        const container = document.getElementById('container')
        const isScrolledToBottom = container.scrollHeight - container.clientHeight <= container.scrollTop + 1

        if (!isScrolledToBottom) container.scrollTop = container.scrollHeight
      }, 101)
    },
    focus () {
      if (!this.textareaDisabled) this.disabled = (!this.disabled && !this.message) || false
    },
    async send () {
      this.$v.$touch()
      if (this.$v.$invalid) return false

      this.disabled = true
      this.textareaDisabled = true

      const params = {
        id: this.orderID,
        message: this.message
      }

      const sendMessage = await this.$store.dispatch('messages/sendMessage', params)
      if (!sendMessage.level) {
        this.disabled = false
        this.textareaDisabled = false

        return this.wrong(this.$t(sendMessage.errorText))
      }

      this.textareaDisabled = false
      this.feeds.push(sendMessage.data)
      this.message = null
      this.scrollToBottom()
    }
  },
  validations: {
    message: {
      maxLength: maxLength(140)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalMessages.vue